"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityChallenges = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityChallenges = class OpportunityChallenges {
    constructor(id, opportunityId, challengeTypeLid, description, mitigationTypeLid, mitigationDescription) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.challengeTypeLid = challengeTypeLid;
        this.description = description;
        this.mitigationTypeLid = mitigationTypeLid;
        this.mitigationDescription = mitigationDescription;
    }
};
exports.OpportunityChallenges = OpportunityChallenges;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityChallenges.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityChallenges.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "challenge_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityChallenges.prototype, "challengeTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityChallenges.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mitigation_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityChallenges.prototype, "mitigationTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mitigation_description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityChallenges.prototype, "mitigationDescription", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.opportunityChallenges),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityChallenges.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "challenge_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityChallenges.prototype, "challenge", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "mitigation_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityChallenges.prototype, "mitigation", void 0);
exports.OpportunityChallenges = OpportunityChallenges = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_challenges"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, String, Number, String])
], OpportunityChallenges);
